module.exports = __webpack_public_path__ + "img/72fac9b3824ecba84f2a1afe079f0338.png";


//////////////////
// WEBPACK FOOTER
// ./classes/heroes/seb/assets/sprites/seb_01.png
// module id = 58
// module chunks = 0